module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "易联云配置",
      "name": "first"
    }
  }, [_c('yilianyunTemplates', {
    ref: "yilianyunTemplates",
    attrs: {
      "get-status": _vm.yilianyunTemplates
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "门店配置",
      "name": "second"
    }
  }, [_c('shopPosTemplates', {
    ref: "shopPosTemplates",
    attrs: {
      "get-status": _vm.shopPosTemplates
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-a74f7d5e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a74f7d5e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/base/setting/yilianyun/index.vue
// module id = 2903
// module chunks = 0